const router = [

{
		path: '/',
		meta: {
			title: '首页'
		},
		name: 'index',
		component: resolve =>
			require(['../views/english/index/index.vue'], resolve),
		hidden: true
	},
	{
		path: '/queryLogistics',
		meta: {
			title: '邮件查询'
		},
		name: 'queryLogistics',
		component: resolve =>
			require(['../views/english/query/queryLogistics.vue'], resolve),
		hidden: true
	},
	// 外部跳转查件
	{
		path: '/waybills_query',
		meta: {
			title: '外部跳转查件'
		},
		name: 'waybills_query',
		component: resolve =>
			require(['@/components/english/swiper/swiper.vue'], resolve),//components/english/swiper/swiper.vue
		hidden: true
	},
	{
		path: '/privacy',
		meta: {
			title: '隐私政策'
		},
		name: 'privacy',
		component: resolve =>
			require(['../views/english/Abouts/privacy.vue'], resolve),
		hidden: true
	},
	{
		path: '/law',
		meta: {
			title: '法律声明'
		},
		name: 'law',
		component: resolve =>
			require(['../views/english/Abouts/law.vue'], resolve),
		hidden: true
	},
	{ //新闻咨询
		path: '/ContactChinaPostalAirlines',
		meta: {
			title: 'ContactChinaPostalAirlines'
		},
		name: 'ContactChinaPostalAirlines',
		component: () => import('@/views/english/Abouts/ContactChinaPostalAirlines.vue'),
	},
	{ //新闻咨询
		path: '/AboutChinaPostalAirlines',
		meta: {
			title: 'AboutChinaPostalAirlines'
		},
		name: 'AboutChinaPostalAirlines',
		component: () => import('@/views/english/Abouts/AboutChinaPostalAirlines.vue'),
	},
	
	
	
]

export default router;